import { useQuery } from '@tanstack/react-query'
import { useFetchWithAuth } from '../session/useFetchWithAuth'

export interface District {
  id: string
  name: string
  city?: {
    id: string
    name: string
  }
}

const API_URL =
  import.meta.env.VITE_EPC_API_URL ?? import.meta.env.REACT_APP_API_URL ?? ''

export const useDistricts = (cityId?: string) => {
  const fetchWithAuth = useFetchWithAuth()

  return useQuery({
    queryKey: ['districts', { cityId }],
    queryFn: async () => {
      const url = cityId
        ? `${API_URL}/districts?cityId=${cityId}`
        : `${API_URL}/districts`

      const response = await fetchWithAuth(url)
      return response as District[]
    },
  })
}
